import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DetectScreenService } from '../../shop/services/detect-screen.service';
import { LocalStorageService } from '../../shop/services/local-storage.service';
import { ProductRange } from './../../shop/interfaces/product-range';
import { Subscription } from 'rxjs';
import { ToggleMenuService } from '../../shop/services/toggle-menu.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})

export class HomeComponent implements OnDestroy, OnInit {

  private status: boolean;

  public products: ProductRange[];
  public screenWidth: number;
  public subscription: Subscription;

  constructor(
    private detectScreen: DetectScreenService,
    private toggleMenuService: ToggleMenuService,

    public ls: LocalStorageService
  ) {
    this.screenWidth = this.detectScreen.getScreen();
  }

  ngOnInit() {
    window.addEventListener('scroll', this.scroll, true);

    this.subscription = this.toggleMenuService.statusChange.subscribe(status => this.status = status);

    // this.bodyClass();
    // this.discountAnimation();
    this.ls.totalCounts();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    window.removeEventListener('scroll', this.scroll, true);
  }

  private bodyClass() {
    const body = document.getElementById('body');
    body.classList.add('home-pg');
  }

  private discountAnimation(): void {
    const block1 = document.getElementById('block1');
    const block2 = document.getElementById('block2');
    const block3 = document.getElementById('block3');
    const block4 = document.getElementById('block4');
    const block5 = document.getElementById('block5');
    const block6 = document.getElementById('block6');
    const block7 = document.getElementById('block7');
    const block8 = document.getElementById('block8');
    const count = document.getElementsByClassName('count');
    const discountBlocks = document.getElementsByClassName('dis-blocks');

    function timers() {

      setTimeout(function () {
        block1.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '1';
          discountBlocks[i].classList.add('unlock-1');
        }
      }, 1500);

      setTimeout(function () {
        block2.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '2';
        }
      }, 3000);

      setTimeout(function () {
        block3.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '3';
          discountBlocks[i].classList.remove('unlock-1');
          discountBlocks[i].classList.add('unlock-2');
        }
      }, 4500);

      setTimeout(function () {
        block4.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '4';
        }
      }, 6000);

      setTimeout(function () {
        block5.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '5';
          discountBlocks[i].classList.remove('unlock-2');
          discountBlocks[i].classList.add('unlock-3');
        }
      }, 7500);

      setTimeout(function () {
        block6.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '6';
        }
      }, 9000);

      setTimeout(function () {
        block7.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '7';
          discountBlocks[i].classList.remove('unlock-3');
          discountBlocks[i].classList.add('unlock-4');
        }
      }, 11500);

      setTimeout(function () {
        block8.classList.add('switch-on');
        for (let i = 0; i < discountBlocks.length; i++) {
          count[i].innerHTML = '8';
        }
      }, 13000);

      setTimeout(function () {
        for (let i = 0; i < discountBlocks.length; i++) {
          discountBlocks[i].classList.remove('switch-on');
          count[i].innerHTML = '0';
          discountBlocks[i].classList.remove('unlock-1');
          discountBlocks[i].classList.remove('unlock-2');
          discountBlocks[i].classList.remove('unlock-3');
          discountBlocks[i].classList.remove('unlock-4');
        }
      }, 15500);
    }

    setInterval(timers, 16500);
  }

  private initLsValues(): void {
    const products: string = localStorage.getItem('productSelection');
    if (products !== null) {
      console.log(products);
      if (products.split(' ') === null) {
        this.ls.productWriteNew(products);
      } else {
        const skuSplit: string[] = localStorage.productSelection.split(' ');
        for (let i = 0; i < skuSplit.length; i++) {
          this.ls.productWriteNew(skuSplit[i]);
        }
      }
    }
  }

  // private scroll = (event: any): void => {
  //   const h = document.documentElement;
  //   const b = document.body;
  //   const st = 'scrollTop';
  //   const sh = 'scrollHeight';
  //   const percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

  //   // Scrollbar
  //   const newHeight = ((9 / 10) * 100) - percent;
  //   const scrollIcn = document.getElementById('scrollIcn');
  //   const scrollIndicator = document.getElementById('scrollIndicator');
  //   const scrollNotify = document.getElementById('scrollNotify');
  //   const scrollText = document.getElementById('scrollText');
  //   scrollIndicator.style.height = newHeight + '%';

  //   if (percent >= 90) {
  //     scrollIcn.classList.add('hide-mouse');
  //   }
  // }

  scroll = (event: any): void => {
    const h = document.documentElement;
    const b = document.body;
    const st = 'scrollTop';
    const sh = 'scrollHeight';
    const percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

    // Scrollbar
    const newHeight = ((9 / 10) * 100) - percent;
    const scrollIcn = document.getElementById('scrollIcn');
    const scrollIndicator = document.getElementById('scrollIndicator');
    const scrollNotify = document.getElementById('scrollNotify');
    const scrollText = document.getElementById('scrollText');

    scrollIndicator.style.height = newHeight + '%';

    if (percent >= 96) {
      scrollIcn.classList.add('hide-scroll');
    }

    if (percent <= 90) {
      if (scrollIcn.classList.contains('hide-scroll')) {
        scrollIcn.classList.remove('hide-scroll');
      }
    }
  }

  public scrollToElement($element): void {
    console.log($element);
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

  private sendMonth(month: string): void {
    this.ls.monthWrite(month);
  }

  public toggleSub(): void {
    this.toggleMenuService.changeStatus(true);
    console.log('service @ home: ' + status);
  }
}
